<template>
  <v-container grid-list-md class="pa-3">
    <v-layout justify-center>
      <v-flex xs12 md10 lg8>
        <v-card flat class="v2-card">
          <v-card-text>
            <v-layout row wrap align-center>
              <v-avatar size="64" color="primary" class="mr-3"><span class="white--text headline font-weight-bold">{{ initials }}</span></v-avatar>
              <div>
                <div class="v2-section-title">{{ synd.syndicate_name || 'None' }}</div>
                <div class="v2-muted">{{ synd.syndicate_abbreviation || 'None' }}</div>
              </div>
              <v-spacer></v-spacer>
              <div>
                <div class="v2-kpi-label">Pay day/s</div>
                <v-chip v-for="d in payDays" :key="d" small label class="ml-0 mr-1">{{ d }}</v-chip>
                <span v-if="!payDays.length" class="font-weight-bold">None</span>
              </div>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex v-for="f in rates" :key="f.label" xs12 sm4>
                <div class="v2-kpi-label">{{ f.label }}</div>
                <div class="font-weight-bold">{{ f.value || 0 }}%</div>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-tabs v-model="tab" color="transparent" slider-color="primary">
            <v2-tab>Contact &amp; Email</v2-tab>
            <v2-tab>Login Credentials</v2-tab>
            <v2-tab>Bank Account</v2-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex v-for="f in contactFields" :key="f.label" xs12 sm6 md4 class="mb-2">
                    <div class="v2-kpi-label">{{ f.label }}</div>
                    <div class="font-weight-bold">{{ f.value }}</div>
                  </v-flex>
                  <v-flex xs12 class="mb-2">
                    <div class="v2-kpi-label">CC Email</div>
                    <v-chip v-for="e in syndicateCcEmails" :key="e" small label class="ml-0 mr-1">{{ e }}</v-chip>
                    <span v-if="!syndicateCcEmails.length" class="font-weight-bold">None</span>
                  </v-flex>
                  <v-flex xs12 class="text-xs-right">
                    <v-btn depressed color="primary" class="ma-0" @click="editDialog = true"><v-icon small left>edit</v-icon>Edit contact</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6 md4 class="mb-2"><div class="v2-kpi-label">User Name</div><div class="font-weight-bold">{{ userInfo.email }}</div></v-flex>
                  <v-flex xs12 sm6 md4 class="mb-2"><div class="v2-kpi-label">Password</div><div class="font-weight-bold">************</div></v-flex>
                  <v-flex xs12 class="text-xs-right">
                    <v-btn depressed color="primary" class="ma-0" @click="passwordDialog = true"><v-icon small left>lock</v-icon>Change password</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6 md4 class="mb-2"><div class="v2-kpi-label">Bank Name</div><div class="font-weight-bold">{{ synd.syndicate_bank_name }}</div></v-flex>
                  <v-flex xs12 sm6 md4 class="mb-2"><div class="v2-kpi-label">Account Number</div><div class="font-weight-bold">{{ synd.syndicate_account_number }}</div></v-flex>
                  <v-flex xs12 sm6 md4 class="mb-2"><div class="v2-kpi-label">Routing Number</div><div class="font-weight-bold">{{ synd.syndicate_routing_number }}</div></v-flex>
                  <v-flex xs12 class="text-xs-right">
                    <v-btn depressed color="primary" class="ma-0" @click="bankAccountDialog = true"><v-icon small left>edit</v-icon>Edit bank account</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="editDialog" persistent max-width="800px">
      <v-card>
        <v-card-title>Contact &amp; Email<v-spacer></v-spacer><v-btn icon @click="editDialog = false"><v-icon>close</v-icon></v-btn></v-card-title>
        <v-card-text>
          <v-form>
            <v-layout row wrap>
              <v-flex xs12 sm4><v-text-field v-model="userInfo.name" label="Contact Person" outline required></v-text-field></v-flex>
              <v-flex xs12 sm4><v-text-field v-model="synd.syndicate_phone.syndicate_phone_number" label="Phone Number" outline required></v-text-field></v-flex>
              <v-flex xs12 sm4><v-text-field v-model="synd.syndicate_phone.syndicate_phone_type" label="Phone Type" outline required></v-text-field></v-flex>
              <v-flex xs12 sm6>
                <v-text-field v-model="synd.syndicate_esign_email" label="E-Sign Email" :rules="[rules.required, rules.email]" hint="Email for receiving Schedule A and Nightly Syndication Report." persistent-hint outline required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-combobox v-model="syndicateCcEmails" :items="syndicateCcEmails" label="Add CC Emails" autocomplete="off" hint="Hit enter to add multiple" persistent-hint hide-selected multiple chips outline></v-combobox>
              </v-flex>
              <v-flex xs12 sm6><v-text-field v-model="synd.syndicate_address.syndicate_street" label="Address" outline required></v-text-field></v-flex>
              <v-flex xs12 sm6><v-text-field v-model="synd.syndicate_address.syndicate_city" label="City" outline required></v-text-field></v-flex>
              <v-flex xs12 sm6><v-select v-model="synd.syndicate_address.syndicate_state" :items="syndicate_state" label="State" return-object outline hide-details></v-select></v-flex>
              <v-flex xs12 sm6><v-text-field v-model="synd.syndicate_address.syndicate_zip" label="Zip" outline required></v-text-field></v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="editDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="submitContactInfo">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ResetPassword v-if="passwordDialog" :passwordDialog="passwordDialog" @closePasswordDialog="passwordDialog = false" />

    <v-dialog v-model="bankAccountDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>Bank Account<v-spacer></v-spacer><v-btn icon @click="bankAccountDialog = false"><v-icon>close</v-icon></v-btn></v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field v-model="synd.syndicate_bank_name" label="Bank Name" outline required></v-text-field>
            <v-text-field v-model="synd.syndicate_account_number" label="Account Number" outline required></v-text-field>
            <v-text-field v-model="synd.syndicate_routing_number" label="Routing Number" outline required></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="bankAccountDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="updateSyndicateBankInfo">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VTab from 'vuetify/es5/components/VTabs/VTab'
import ResetPassword from '../../components/Dialogs/ResetPassword'
import profile from '../mixins/profile'

const orNA = v => (v != null ? v : 'N/A')
const toList = v => {
  if (Array.isArray(v)) return v
  try {
    return JSON.parse(v) || []
  } catch (e) {
    return v ? [v] : []
  }
}

export default {
  mixins: [profile],
  components: { ResetPassword, 'v2-tab': VTab },
  data: () => ({ tab: 0 }),
  computed: {
    synd() {
      return this.userInfo.syndication || {}
    },
    initials() {
      return (this.synd.syndicate_name || '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
    },
    payDays() {
      return toList(this.synd.pay_days)
    },
    rates() {
      return [
        { label: 'Default Participation', value: this.synd.syndicate_participation_percent },
        { label: 'Management Fee', value: this.synd.syndicate_management_fee_percentage },
        { label: 'Syndication Fee', value: this.synd.syndicate_fee_percentage },
      ]
    },
    contactFields() {
      const phone = this.synd.syndicate_phone || {}
      const a = this.synd.syndicate_address || {}
      return [
        { label: 'Contact Person', value: this.userInfo.name },
        { label: 'Phone Number', value: orNA(phone.syndicate_phone_number) },
        { label: 'Phone Type', value: orNA(phone.syndicate_phone_type) },
        { label: 'E-Sign Email', value: this.synd.syndicate_esign_email },
        { label: 'Address', value: orNA(a.syndicate_street) },
        { label: 'City', value: orNA(a.syndicate_city) },
        { label: 'State', value: orNA(a.syndicate_state) },
        { label: 'Zip', value: orNA(a.syndicate_zip) },
      ]
    },
  },
}
</script>
